/**
 * Story 87.22: MissingCredentialError HTTP interceptor.
 *
 * Перехватывает HTTP 412 responses с body { error: 'missing_credential', ... }
 * и показывает modal с deep link "Перейти к настройкам".
 *
 * Backend KeySelector.select() raises MissingCredentialError(412) когда
 * для запрошенной operation нет marketplace_account с подходящим scope.
 */

import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { MissingCredentialModalService } from '../services/missing-credential-modal.service';

export const missingCredentialInterceptor: HttpInterceptorFn = (req, next) => {
  const modal = inject(MissingCredentialModalService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Backend MissingCredentialError = HTTP 412 + structured detail
      if (
        error.status === 412 &&
        error.error?.detail?.error === 'missing_credential'
      ) {
        const detail = error.error.detail;
        modal.show({
          marketplace: detail.marketplace,
          operation: detail.operation,
          requiredScope: detail.required_scope || [],
          message: detail.message,
        });
      }
      return throwError(() => error);
    }),
  );
};
